import React, { useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import "./Layout.css";

const Layout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const { user, logout } = useAuth();

  const go = (path) => {
    navigate(path);
    setMenuOpen(false);
  };

  return (
    <div className="layout">
      <header className="header">
        <div className="container">
          <div className="header-content">
            <div className="logo">
              <div
                className="logo-container"
                onClick={() => go("/")}
                style={{ cursor: "pointer" }}
              >
                <img
                  src="/itsmybot_logo.webp"
                  alt="ItsMyBot Logo"
                  className="company-logo"
                />
                <h1>Payroll Management</h1>
              </div>
            </div>

            {/* Hamburger button — mobile only */}
            <button
              className="hamburger"
              onClick={() => setMenuOpen((o) => !o)}
              aria-label={menuOpen ? "Close menu" : "Open menu"}
              aria-expanded={menuOpen}
            >
              <span className={`hamburger-bar ${menuOpen ? "open" : ""}`} />
              <span className={`hamburger-bar ${menuOpen ? "open" : ""}`} />
              <span className={`hamburger-bar ${menuOpen ? "open" : ""}`} />
            </button>

            <nav className={`nav ${menuOpen ? "nav-open" : ""}`}>
              <ul className="nav-list">
                <li className="nav-item">
                  <button
                    onClick={() => go("/dashboard")}
                    className={`nav-link ${location.pathname === "/dashboard" ? "active" : ""}`}
                  >
                    Dashboard
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    onClick={() => go("/tutors")}
                    className={`nav-link ${location.pathname === "/tutors" ? "active" : ""}`}
                  >
                    Rates
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    onClick={() => go("/mentors")}
                    className={`nav-link ${location.pathname === "/mentors" ? "active" : ""}`}
                  >
                    Mentors
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    onClick={() => go("/counselors")}
                    className={`nav-link ${location.pathname === "/counselors" ? "active" : ""}`}
                  >
                    Counselors
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    onClick={() => go("/demo-lessons")}
                    className={`nav-link ${location.pathname === "/demo-lessons" ? "active" : ""}`}
                  >
                    Demo Lessons
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    onClick={() => go("/wise-mappings")}
                    className={`nav-link ${location.pathname === "/wise-mappings" ? "active" : ""}`}
                  >
                    Wise
                  </button>
                </li>
                {user?.role === "SUPER_ADMIN" && (
                  <li className="nav-item">
                    <button
                      onClick={() => go("/users")}
                      className={`nav-link ${location.pathname === "/users" ? "active" : ""}`}
                    >
                      Users
                    </button>
                  </li>
                )}
                <li className="nav-item nav-user-section">
                  {user?.name && <span className="user-name-label">{user.name}</span>}
                  <button onClick={() => { logout(); setMenuOpen(false); }} className="logout-btn">
                    Logout
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        {/* Backdrop to close menu on outside tap */}
        {menuOpen && <div className="nav-backdrop" onClick={() => setMenuOpen(false)} />}
      </header>

      <main className="main">
        <div className="container">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Layout;
